<div class="sidebar">
  <nz-anchor
    [nzAffix]="false"
    [nzOffsetTop]="110"
    (nzChange)="onAnchorChange($event)"
    *ngIf="flag"
  >
    <nz-link
      *ngFor="let item of list; let i = index"
      [nzHref]="'#' + formatId(item.name)"
      [nzTitle]="item.name"
      [class.default-active]="
        (!activeId || activeId === '#' + formatId(formatId(item.name))) &&
        i === 0
      "
    ></nz-link>
  </nz-anchor>

  <!-- <div class="part">
    <div class="part1">
      <img src="../../../../assets/images/help/kefu.png" alt="" />
    </div>
    <div class="part2">需要进一步帮助</div>
    <div class="part3">工作时间：9:00-22:00</div>
    <div class="part4" (click)="showCustomerService()">点击查看</div>
  </div> -->
</div>
